import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import cell from '../../assets/img/genetic/gen_banner1.png'
import { Text } from '../../components/Text'
import FooterSection from '../Footer'
import ConnectUs from '../../components/ConnectUs'
import Header from '../Header'
import gen_d_1 from '../../assets/img/genetic/gen_d_1.png'
import gen_d_2 from '../../assets/img/genetic/gen_d_2.png'
import gen_d_3 from '../../assets/img/genetic/gen_d_3.png'
import gen_d_4 from '../../assets/img/genetic/gen_d_4.png'
import gen_d_5 from '../../assets/img/genetic/gen_d_5.png'
import intro from '../../assets/img/genetic/gen_banner.jpg'
import bg from '../../assets/img/genetic/gen_card_bg.png'
import time from '../../assets/img/icon/all-white.png'
import QASectionSub from '../../components/sections/QASectionSub'
import { InfoSection } from '../../components/InfoSection'
import { services } from '../../assets/dummy.js'
import DownloadSection from '../../components/DownloadSection/index.jsx'
import ServiceModal from '../../components/ServiceCardModal/index.jsx'

import TherapyCard from '../../components/TherapyCard'
import carepay from '../../assets/img/carepay/carepay_bg.png'
import android from '../../assets/img/carepay/android.png'
import apple from '../../assets/img/carepay/apple.png'
import logo from '../../assets/img/carepay/carepay_logo.png'

export default function Genetic () {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedService, setSelectedService] = useState(null)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50) 
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const filteredServices = services.filter(
    service => service.tag === 'Генетик шинжилгээ'
  )
  const openModal = service => {
    setSelectedService(service.content)
    setIsModalOpen(true)
  }

  // Close Modal Function
  const closeModal = () => {
    setSelectedService(null)
    setIsModalOpen(false)
  }
  return (
    <>
      <Helmet>
        <title>CellClinic - Генетик шинжилгээ</title>
        <meta
          name='description'
          content='Хүн анх төрөхдөө зарим төрлийн хавдрын эрсдэлээ удмын
                мэдээлэлдээ тээж ирдэг. Хавдрын генетик эрсдэлийг мэдэх нь
                урьдчилан сэргийлэх, эрт илрүүлэх, амьдралын хэв маягаа өөрчлөх,
                өвчнийг хянах боломжийг олгодог.'
        />
      </Helmet>

      <div
        className='bg-gradient-to-l from-[#89D4E5] to-[#08273C] bg-cover bg-center bg-no-repeat h-[100vh] '
        style={{
          backgroundImage: `url(${cell})`,
          mixBlendMode: 'luminosity'
        }}
      >
        <div
          className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full  z-50 transition-all duration-300 ${
            isScrolled
              ? 'bg-blue shadow-md h-[7vh] top-1 max-w-[1440px] extraScreen:max-w-[1500px]'
              : 'bg-transparent h-[5vh]'
          }`}
        >
          <Header
            color={isScrolled ? 'black' : 'white'}
            gradientColor={isScrolled ? 'bg-white/90' : 'bg-none'}
          />
        </div>
        {/* <Header
          color='white'
          // gradientColor='bg-gradient-to-l from-[#89D4E5] to-[#08273C]'
        /> */}
        <div className='h-[90vh] flex flex-col  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'>
          <div className='flex-1 flex flex-row items-center justify-center gap-5 p-20 mobile:gap-0 mobile:p-8 mobile:flex-col tablet:flex-col tablet:py-2 tablet:px-5'>
            <div className='w-1/2 mobile:w-full tablet:w-full'>
              <button
                className='backdrop-blur-xl bg-white/10 py-1.5 px-5 text-white rounded-xl mt-5 
            flex items-center justify-center gap-2 cursor-pointer text-xs mobile:mb-4 tablet:mb-4 mobile:hidden'
              >
                <img src={time} alt='ds' className='w-6 h-6 ' />
                Генетик шинжилгээ
              </button>
              <p className='text-[36px] font-inter-bold mobile:text-[32px] text-white mt-4 tablet:text-[24px]'>
                Ген бол хүний биологийн мэдээллийн үндсэн нэгж юм
              </p>
              <Text className='text-white/75 mt-5 max-w-[450px] mobile:text-justify text-[16px] mobile:mb-4 tablet:max-w-full tablet:mb-4 tablet:text-[16px]'>
                Генетикийн шинжилгээ хийлгэснээр та өөрийн болон гэр бүлийнхээ
                эрүүл мэндийг урьдчилан хамгаалах боломжтой.
              </Text>
            </div>

            <div className='w-1/2  mobile:w-full mobile:mt-5 tablet:w-[400px]'>
              {/* <div
                className='relative self-center bg-cover bg-center rounded-3xl h-[492px] mobile:h-[300px] tablet:h-[300px]'
                style={{ backgroundImage: `url(${cell})` }}
              /> */}
            </div>
          </div>
        </div>
      </div>
      <div className='maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'>
        <div className='flex flex-col justify-center items-start p-20  mobile:rounded-[24px] mobile:p-5 tablet:p-5'>
          <div className=' bg-[#EBF7FF] p-10 mobile:p-5'>
            <button
              className='text-[#236E9C]  border-l-2 border-[#236E9C] text-[26px] px-5 font-bold text-start 
                  bg-gradient-to-l from-[#FFFFFF1F] to-[#72C5B91F]
          mobile:text-[24px] mobile:w-[300px] 
          tablet:w-full tablet:text-[24px] tablet:mb-5'
            >
              Өвчний шинж тэмдэг илрэхийг хүлээх биш, генетик шинжилгээ хийлгэж
              эрсдэлээс урьдчилан сэргийлэх нь шинжлэх ухаанч, ухаалаг шийдэл
              юм.
            </button>
            <InfoSection
              title=''
              text='Бид БНСУ-ын геномын оношилгооны салбарт тэргүүлэх байр суурьтай Dx&Vx компанитай хамтран Next Generation Sequencing (NGS), Chromosomal Microarray, SNP Microarray технологид суурилсан дараах 4 төрлийн генетикийн шинжилгээг Монгол Улсад нэвтрүүлж байна.'
              imgSrc={gen_d_1}
              list={[
                '• Хавдрын эрсдэлийг тодорхойлох генетиĸ шинжилгээ – 11 төрлийн хавдрын удамшлын эрсдэлийг тодорхойлно',
                '• Төрөхөөс өмнөх генетикийн шинжилгээ (НИПТ) – Ургийн хромосомын эмгэг болон хүйсийг тодорхойлно.',
                '• Хромосомын тооны болон бүтцийн өөрчлөлтийн шинжилгээ – Төрсний дараах буюу нярайн хромосомын эмгэгийг тодорхойлно.',
                '• Үр хөврөлийн хромосомын эмгэгийг илрүүлэх шинжилгээ (PGT) – Үр хөврөл шилжүүлэн суулгахын өмнөх хромосомын өөрчлөлтийг илрүүлнэ.'
              ]}
            />
            <InfoSection
              title='GENOMECHECK H – Хавдрын эрсдэлийг тодорхойлох генетик шинжилгээ (Бүх насныханд)'
              text='GENOMECHECK H нь 11 төрлийн хавдрын удамшлын эрсдэлийг тодорхойлох өндөр нарийвчлалтай генетикийн шинжилгээ юм. Энэхүү шинжилгээ нь уушги, ходоод, элэг, нойр булчирхай, хөх, бөөр, улаан хоолой, давсаг, цөсний хүүдий, бамбай булчирхай, бүдүүн шулуун гэдэсний хорт хавдрын эрсдэлийг үнэлнэ.
Шинжилгээ нь дээрх хорт хавдруудтай холбоотой 57 генийн полиморфизм дээр суурилсан бөгөөд SNP Microarray технологийг ашиглан генетикийн өгөгдлийг нарийвчлан шинжилдэг. Энэ нь хавдрын эрсдэлийг эрт илрүүлэх, урьдчилан сэргийлэх, хувь хүний эрүүл мэндийн менежментийг сайжруулахад чухал ач холбогдолтой. 
'
              imgSrc={gen_d_3}
              reverse
            />
            <button
              className='text-[#236E9C]  border-l-2 border-[#236E9C]  px-5 text-[26px] font-inter-bold mb-5 mt-5
             bg-gradient-to-l from-[#FFFFFF1F] to-[#72C5B91F] text-start 
          mobile:text-[24px] mobile:w-full tablet:w-full tablet:text-[30px] tablet:mb-4'
            >
              GenomeCheck H нь хавдраас урьдчилан сэргийлэх, хавдраар өвдөхгүй
              байх, урт удаан чанартай амьдралыг бий болгох боломжийг олгодог.
            </button>
            <InfoSection
              title='GENOMECHECK M (НИПТ) - Төрөхөөс өмнөх генетикийн шинжилгээ (Ургийн эрт үед)'
              text='GENOMECHECK M (НИПТ) буюу ургийн хромосомын эмгэг, хүйс тодорхойлох уг шинжилгээ нь жирэмсний эрт үед (10-24 долоо хоног) эхийн цуснаас ургийн чөлөөт ДНХ -г ялган авч хромосомын тооны болон бүтцийн өөрчлөлтийг оношлох өндөр нарийвчлалтай дэвшилтэт шинжилгээ юм. Энэ шинжилгээ нь Даун, Эдвардс, Патаугийн хам шинж зэрэг 10, 123, 424 хромосомын эмгэгийг тодорхойлохоос гадна ургийн ХҮЙСИЙГ тодорхойлдог.'
              text2='Эрсдэлгүй, энгийн хурдан хийгддэг энэ шинжилгээ нь ургийн эрүүл мэндийн байдлыг мэдэх боломжийг хамгийн эрт буюу эхо шинжилгээ хийх боломжтой цаг үеэс өмнө олгодгоороо онцлог юм. '
              imgSrc={gen_d_2}
            />
            <InfoSection
              title='GENOMECHECK G – Хромосомын тооны болон бүтцийн өөрчлөлтийн генетик шинжилгээ (Дөнгөж төрсөн нярайд)'
              text='GENOMECHECK G нь шинжилгээ нь хүний хромосомын тоо, бүтцийг нарийвчлан судалж, удамшлын өвчин, төрөлхийн гажиг, үргүйдэл, зулбалт, хөгжлийн хоцрогдолтой холбоотой өөрчлөлтүүдийг илрүүлэхэд ашиглагддаг дэвшилтэт шинжилгээ юм. 
              Энэхүү шинжилгээгээр хромосомын тооны томоохон өөрчлөлтүүд (Даун, Эдвардсын хам шинж), хромосомын бүтцийн өөрчлөлтүүд (ДиЖоржийн хам шинж) илрүүлэхээс гадна аутизмын хүрээний эмгэгтэй холбоотой хромосомын өөрчлөлтүүд болон бусад 1341 төрлийн генетикийн эмгэгүүдийг тодорхойлох боломжтой.'
              text2='Дөнгөж төрсөн нярайд энэхүү шинжилгээг хийх нь эцэг эхийн сэтгэл зүйн тайван байдлыг хангаж, хүүхдийн эрүүл мэндтэй холбоотой асуудлыг эрт илрүүлэх, мөн эмгэг илэрсэн тохиолдолд цаг алдалгүй арга хэмжээ авах боломжийг бүрдүүлдэг.
              '
              imgSrc={gen_d_4}
              reverse
            />
            <button
              className='text-[#236E9C]  border-l-2 border-[#236E9C]  px-5 text-[26px] font-inter-bold mb-5 mt-5
             bg-gradient-to-l from-[#FFFFFF1F] to-[#72C5B91F]
            text-start 
          mobile:text-[24px] mobile:w-full tablet:w-full tablet:text-[30px] tablet:mb-4'
            >
              НИПТ нь ургийн хромосомын эмгэгийг жирэмсний эхний үе шатанд
              тодорхойлох аюулгүй, найдвартай арга юм.
            </button>
            <InfoSection
              title='GENOMECHECK PV - (PGT) Үр хөврөлийн хромосомын эмгэгийн шинжилгээ (Үр хөврөлд)'
              text='GENOMECHECK PV (PGT)  буюу үр хөврөл шилжүүлэн суулгахын өмнөх хромосомын өөрчлөлтүүдийг илрүүлэх шинжилгээ нь лабораторийн орчинд үр тогтоолт хийн гарган авсан үр хөврөлийн хромосомын тооны болон бүтцийн өөрчлөлтийг эрүүл үр хөврөлийг эхийн умайд шилжүүлэн суулгах зорилготой дэвшилтэт арга юм. Энэ нь үргүйдэл, шалтгаан тодорхойгүй зулбалттай гэр бүлүүд, удамшлын өвчний эрсдэлтэй хосуудын хувьд чухал ач холбогдолтой.  '
              imgSrc={gen_d_5}
            />
          </div>
        </div>
        <div className=' z-10 maxScreen:px-20 extraScreen:px-20 relative'>
          <DownloadSection
            image={intro}
            pdfLink='/pdf/CELLCLINIC_GENOMECHECK.pdf'
            gradient='linear-gradient(270deg, #89D4E5 0%, #0C2C41 40%)'
            subjectPassed='Генетик шинжилгээний танилцуулга'
            text1='Та эрүүл мэнддээ анхаарч, хамгийн дэвшилтэт технологийг сонирхож буйд тань баяр хүргэе! 🎉'
            text2='Өмнө нь зөвхөн өндөр хөгжилтэй орнуудад хийгддэг байсан нарийвчилсан генетик шинжилгээг одоо та эх орондоо, дэргэдээсээ авах боломжтой боллоо. Манай клиник дэлхийн стандартад нийцсэн, найдвартай генетикийн шинжилгээг санал болгож, таны эрүүл мэндийн удамшлын эрсдэлээ тодорхойлох, хувь хүний онцлогт тохирсон урьдчилан сэргийлэлт хийх боломжийг олгож байна.'
            text3=''
            attachText='Танд зориулсан үйлчилгээний дэлгэрэнгүй танилцуулгыг доорх холбоосоор татаж авна уу.'
            bonus='Хэрэв танд нэмэлт мэдээлэл хэрэгтэй бол бидэнд хэзээд хандаарай!'
            ccEmail='genetic@cellclinic.mn'
          ></DownloadSection>
        </div>
        <div
          className='h-full p-20 flex flex-col items-center justify-center rounded-xl 
      mobile:mt-5 mobile:mb-5 mobile:max-w-full mobile:p-0 mobile:px-5  
      maxScreen:p-0 extraScreen:p-0 maxScreen:py-20 extraScreen:py-20  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'
        >
          <main className='flex flex-col justify-center'>
            <div
              className='bg-cover bg-center bg-no-repeat flex flex-row justify-between items-center py-5 px-5 rounded-2xl mobile:flex-col mobile:justify-center mobile:items-center '
              style={{
                backgroundImage: `url(${carepay})`,
                mixBlendMode: 'luminosity'
              }}
            >
              <div className='h-20 w-1/5 mobile:w-full ml-5 mobile:ml-40'>
                <img
                  className='cursor-pointer h-[40px] mt-4'
                  src={logo}
                  alt='logo'
                ></img>
              </div>
              <div className='text-white w-4/5 px-20 text-center text-[24px]  mobile:text-[20px] mobile:mb-2 mobile:px-0 mobile:w-full'>
                Хүү, шимтгэлгүй хуваан төлөх онцгой нөхцөл
              </div>
              <div className='w-[160px] mobile:w-full cursor-pointer mobile:flex  mobile:items-center mobile:flex-col flex justify-end flex-col'>
                <img
                  className=' mobile:h-[40px]'
                  src={android}
                  alt='dd'
                  onClick={() =>
                    window.open(
                      'https://play.google.com/store/apps/details?id=com.bitsoft.carepay'
                    )
                  }
                ></img>
                <img
                  src={apple}
                  alt='ff'
                  className='mt-2 cursor-pointer  mobile:h-[40px]'
                  onClick={() =>
                    window.open(
                      'https://apps.apple.com/mn/app/carepay/id6446045879'
                    )
                  }
                ></img>
              </div>
            </div>
          </main>
        </div>
        <div
          className='px-20 h-full mb-20 
         mobile:h-full mobile:px-5 mobile:mb-0 
        tablet:h-full tablet:p-10
          maxScreen:px-20 extraScreen:px-20 '
        >
          <div
            className='p-10 flex flex-col items-center justify-center rounded-3xl bg-cover bg-center bg-no-repeat
          mobile:p-0 mobile:w-full 
          tablet:p-5 tablet:mt-10 
          '
            style={{
              backgroundImage: `url(${bg})`,
              backgroundRepeat: 'no-repeat'
            }}
          >
            <p className='text-[32px] text-center text-[#235998]  font-inter-bold mobile:text-[22px] mobile:font-bold tablet:text-[28px] uppercase mobile:p-4'>
              Санал болгож буй генетик шинжилгээнүүд
            </p>
            <div
              className='grid grid-cols-4 gap-5 py-5 
            mobile:grid-cols-1 mobile:px-5 mobile:gap-0 mobile:w-full mobile:py-0 mobile:mr-4
            tablet:grid-cols-2 tablet:px-5 
            extraScreen:gap-8  maxScreen:gap-8 '
            >
              {filteredServices.map(item => (
                <div className='group '>
                  <TherapyCard data={item} callModal={openModal}></TherapyCard>
                </div>
              ))}
              {isModalOpen && (
                <ServiceModal
                  selectedService={selectedService}
                  closeModal={closeModal}
                />
              )}
            </div>
          </div>
        </div>
        <div className='px-20 mb-20 mobile:px-5 mobile:mt-5 mobile:mb-5 tablet:p-5 '>
          <QASectionSub
            tags={[
              { name: 'GenomeCheck H', category: 'Genomecheck H' },
              { name: 'GenomeCheck M', category: 'Genomecheck M' },
              { name: 'GenomeCheck G', category: 'Genomecheck G' },
              { name: 'GenomeCheck PV', category: 'Genomecheck PV' }
            ]}
            category='Генетик оношилгоо'
          />
        </div>
        {/* contact us section */}
        <div className='px-20  mobile:px-5 tablet:px-5 '>
          <ConnectUs bgImage='blue'></ConnectUs>
        </div>
        {/* footer section */}
        <div className='px-20   mobile:px-5 tablet:p-5 '>
          <FooterSection></FooterSection>
        </div>
      </div>
    </>
  )
}
